import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { Dispatch } from '@reduxjs/toolkit';
import { ApiRequest } from './models/apiRequest';
import { CLIENT_STORE_NAME, actions } from './store';
import { ClientProSubscriptionInfo } from './types';

export const getClientProSubscriptionInfo = () => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const request = {};
      const response = await frontendActions.webTradingApiCall<ClientProSubscriptionInfo>(
        CLIENT_STORE_NAME,
        ApiRequest.ClientProSubscriptionGet1,
        request,
        dispatch
      );
      dispatch<any>(actions.clientProSubscriptionInfoFetched(response));
    } catch (error) {
      console.error('Error fetching client pro subscription info:', error);
    }
  };
};
